import $ from 'jquery'

export default function triggerReadMore() {
  $('.js-hidden-content').hide()

  $('.js-toggle-more-content').click(function trigger(e) {
    e.preventDefault()
    $(this)
      .prev('.js-hidden-content')
      .slideToggle()
    $(this).toggleClass('is-visible')

    if ($(this).hasClass('is-visible')) {
      $(this)
        .find('span')
        .text(`${wpI18n.showless}`)
    } else {
      $(this)
        .find('span')
        .text(`${wpI18n.showmore}`)
    }
  })
}
